import React from 'react';
import { CContainer, CBreadcrumb, CBreadcrumbItem, CCard,
   CCardHeader, CCardBody, CRow, CCol } from '@coreui/react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import SupplierInputs from '../../components/SupplierInputs/SupplierInputs';
import { updateSupplierRequest } from '../../store/supplier/supplierActions';

const UpdateSupplier = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isLoading = useSelector(state => state.supplierReducer.isLoading);
  const submitResponse = useSelector(state => state.supplierReducer.updateSupplierData);
  const initialData = location.state?.supplier || null;

  const handleSubmit = (data) => {
    dispatch(updateSupplierRequest({ ...data, navigate }));
  };

  const handleCancel = () => {
    navigate('/suppliers');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/suppliers" onClick={e => 
          { e.preventDefault(); handleCancel(); }}>{t('suppliers')}</CBreadcrumbItem>
        <CBreadcrumbItem active>{t('updateSupplier')}</CBreadcrumbItem>
      </CBreadcrumb>
      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader><h4>{t('updateSupplier')}</h4></CCardHeader>
            <CCardBody>
              <SupplierInputs onSubmit={handleSubmit} onCancel={handleCancel} 
              isLoading={isLoading} submitResponse={submitResponse} 
              initialData={initialData} isEdit />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

export default UpdateSupplier; 